import { render } from "./ResolveSuspensionModal.vue?vue&type=template&id=a386be1a&scoped=true&ts=true&lang=pug"
import script from "./ResolveSuspensionModal.vue?vue&type=script&lang=ts"
export * from "./ResolveSuspensionModal.vue?vue&type=script&lang=ts"

import "./ResolveSuspensionModal.vue?vue&type=style&index=0&id=a386be1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a386be1a"]])

export default __exports__